// extracted by mini-css-extract-plugin
module.exports = {"LotStick":"LotStick_LotStick__3F-XL","stick":"LotStick_stick__2N3e6"};